import React, { useState, useEffect } from "react";
import "./Navbar.css";
import { FaBars, FaTimes } from "react-icons/fa";
import { NavLink } from "react-router-dom";
import logo from "../../Gemco-Website-Images/logo.png";  

const Navbar = () => {
  const [click, setClick] = useState(false);
  const [color, setColor] = useState(false);

  const handleClick = () => setClick(!click);

  const closeMobileMenu = () => setClick(false);

  useEffect(() => {
    const changeColor = () => {
      if (window.scrollY >= 90) {
        setColor(true);
      } else {
        setColor(false);
      }
    };

    window.addEventListener("scroll", changeColor);

    return () => {
      window.removeEventListener("scroll", changeColor);
    };
  }, []);

  return (
    <div className={color ? "header header-bg" : "header"}>
      <div className="container navbar">

        {/* Logo */}
        {/* <NavLink to="/" className="logo zerra" onClick={closeMobileMenu}>
          ZERRA
        </NavLink> */}
        <NavLink to="/" className="logo gemcome" onClick={closeMobileMenu}>
           <img src={logo} className="gemcome_logo" alt='gemcome logo'/>
        </NavLink>

        {/* Hamburger Icon */}
        <div className="hamburger" onClick={handleClick}>
          {click ? (
            <FaTimes size={20} style={{ color: "#fff" }} />
          ) : (
            <FaBars size={20} style={{ color: "#fff" }} />
          )}
        </div>

        {/* Menu */}
        <ul className={click ? "nav-menu active mt-2" : "nav-menu mt-3"}>
          <li className="nav-item">
            <NavLink
              to="/"
              onClick={closeMobileMenu}
              className={({ isActive }) =>
                `nav-link ${isActive ? "active" : ""} ${
                  color ? "nav-link-color" : ""
                }`
              }
            >
              Home
            </NavLink>
          </li>

          <li className="nav-item">
            <NavLink
              to="/about-us"
              onClick={closeMobileMenu}
              className={({ isActive }) =>
                `nav-link ${isActive ? "active" : ""} ${
                  color ? "nav-link-color" : ""
                }`
              }
            >
              About Us
            </NavLink>
          </li>

          <li className="nav-item">
            <NavLink
              to="/services"
              onClick={closeMobileMenu}
              className={({ isActive }) =>
                `nav-link ${isActive ? "active" : ""} ${
                  color ? "nav-link-color" : ""
                }`
              }
            >
              Services
            </NavLink>
          </li>

          <li className="nav-item">
            <NavLink
              to="/our-sector"
              onClick={closeMobileMenu}
              className={({ isActive }) =>
                `nav-link ${isActive ? "active" : ""} ${
                  color ? "nav-link-color" : ""
                }`
              }
            >
              Our Sectors
            </NavLink>
          </li>

          <li className="nav-item">
            <NavLink
              to="/our-projects"
              onClick={closeMobileMenu}
              className={({ isActive }) =>
                `nav-link ${isActive ? "active" : ""} ${
                  color ? "nav-link-color" : ""
                }`
              }
            >
              Our Projects
            </NavLink>
          </li>

          <li className="nav-item">
            <NavLink
              to="/contact-us"
              onClick={closeMobileMenu}
              className={({ isActive }) =>
                `nav-link ${isActive ? "active" : ""} ${
                  color ? "nav-link-color" : ""
                }`
              }
            >
              Contact Us
            </NavLink>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Navbar;